import React, { Component } from "react";
import { jsUcfirst } from "../utils/helpers";
import * as moment from "moment";
import Moment from "react-moment";
import "moment/locale/es";
// Ignore
moment.suppressDeprecationWarnings = true;

export default class Barclasisin extends Component {
	render() {
		const jsUcfirst = string =>
			string.charAt(0).toUpperCase() + string.slice(1);

		return (
			<div className="barcontclasi itemclasi sin">
				<div className="bar barkeyclasi_sin">{this.props.clave}</div>
				<div className="barfecha">
					{moment(this.props.fecha).isValid() ? (
						<Moment filter={jsUcfirst} format="dddd D	MMM" locale="es">
							{this.props.fecha}
						</Moment>
					) : (
						"s/f"
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Barclasisin.js